import Vue from 'vue'
import { message, Spin, Modal } from 'ant-design-vue'

Vue.use(Spin)
Vue.use(Modal)
Vue.prototype.$message = message
Vue.prototype.$confirm = Modal.confirm
